import axios from "axios";
import Config from "../utils/Config";
import helpers from "../utils/Helpers";

/**
 * Provider-facing quote request API.
 * List all quote requests, get one, update with quoted amount and status.
 */
class QuoteService {
  getAuthHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("trp_tk")}`,
      },
    };
  }

  /** Get all quote requests for the provider's policies */
  async getQuoteRequests(filters = {}) {
    try {
      const params = {};
      if (filters.status) params.status = filters.status;
      if (filters.policy_slug) params.policy_slug = filters.policy_slug;

      const response = await axios.get(
        `${Config.apiUrl}/provider/quote-requests`,
        { ...this.getAuthHeaders(), params }
      );
      return helpers.handleApiSuccess(
        response,
        "Quote requests fetched successfully"
      );
    } catch (error) {
      return helpers.handleApiError(
        error,
        "An error occurred while fetching quote requests"
      );
    }
  }

  /** Get a single quote request by id */
  async getQuoteRequest(id) {
    try {
      const response = await axios.get(
        `${Config.apiUrl}/provider/quote-requests/${id}`,
        this.getAuthHeaders()
      );
      return helpers.handleApiSuccess(
        response,
        "Quote request fetched successfully"
      );
    } catch (error) {
      return helpers.handleApiError(
        error,
        "An error occurred while fetching quote request"
      );
    }
  }

  /**
   * Update quote request: set quoted amount and/or status
   * @param {string} id - Quote request id
   * @param {Object} payload - { quoted_amount?, status? }  status: pending | quoted | accepted | rejected
   */
  async updateQuoteRequest(id, payload) {
    try {
      const response = await axios.patch(
        `${Config.apiUrl}/provider/quote-requests/${id}`,
        payload,
        this.getAuthHeaders()
      );
      return helpers.handleApiSuccess(
        response,
        "Quote updated successfully"
      );
    } catch (error) {
      return helpers.handleApiError(
        error,
        "An error occurred while updating quote"
      );
    }
  }
}

const quoteService = new QuoteService();
export default quoteService;
